import { render, staticRenderFns } from "./DeviceFieldCardV2.vue?vue&type=template&id=17b760cc&scoped=true&"
import script from "./DeviceFieldCardV2.vue?vue&type=script&lang=js&"
export * from "./DeviceFieldCardV2.vue?vue&type=script&lang=js&"
import style0 from "./DeviceFieldCardV2.vue?vue&type=style&index=0&id=17b760cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b760cc",
  null
  
)

export default component.exports